import { SET_USER_PREFERENCES } from "../actions/userPreferencesTypes";

const initialState = {
  timezone: "",
  dateformat: "",
  timeformat: "",
};

const userPreferencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_PREFERENCES:
      return { ...action.payload }; // Replaces the entire object
    default:
      return state;
  }
};

export default userPreferencesReducer;
